import { useEffect } from 'react';
import { hasElements } from 'utils';
import connect from 'components/Shared/connect';
import { loadBrandsMenu } from 'components/Header/actions';
import { BrandsNavigationBlock } from 'models/BrandsNavigationBlock';
import { Panel } from 'components/Navigation/';

interface MergedProps extends BrandsNavigationBlock {
  loadBrandsMenu: () => void;
}
export const BrandsBlock = connect<MergedProps, BrandsNavigationBlock>(undefined, dispatch => ({
  loadBrandsMenu: () => void dispatch(loadBrandsMenu())
}))(function Brands({ loadBrandsMenu, ...props }: MergedProps) {
  useEffect(() => {
    hasElements(props.items) || loadBrandsMenu();
  }, [props.items, loadBrandsMenu]);
  return <Panel {...props} />;
});
